<template>
<AppLayout>
    <Modal :isOpen="cartStore.modalState.isOpen" @close="cartStore.modalState.cancelAction">
        <template #header>
            <h2 class="text-xl text-white font-bold">إفراغ السلة</h2>
        </template>
        <template #body>
            <p>{{ cartStore.modalState.message }}</p>
        </template>
        <template #footer>
            <div class="flex flex-col justify-center w-full">
                <div class="w-full mb-5 ">
                    <button @click="cartStore.modalState.confirmAction"
                        class="bg-tazej-green-primary text-white  w-full">نعم</button>
                </div>

                <div class="  w-full">
                    <button @click="cartStore.modalState.cancelAction"
                        class="bg-tazej-greenWithTransparency-primary w-full ">لا</button>
                </div>
            </div>
        </template>
    </Modal>
    <div>
        <Slider />
    </div>
    <div class="px-4 md:px-10 lg:px-8 xl:px-10 my-12 w-full min-w-0">
        <div id="categories-sticky-trigger" class="h-px w-full"></div>
        <div
            v-if="showHomeCatalogLoader"
            class="flex flex-col items-center justify-center gap-4 py-16 px-4 text-center"
            aria-busy="true"
            aria-live="polite">
            <FirstVisitLoader
                v-if="productsStore.isFirstVisit"
                :progress="productsStore.loadingProgress"
                :stage="productsStore.loadingStage"
                :is-first-visit="productsStore.isFirstVisit" />
            <LoadingSpinner />
            <p class="text-tazej-gray-500 text-base max-w-sm">جاري تحميل التصنيفات والمنتجات…</p>
        </div>
        <template v-else>
        <div v-show="showNormalCategoriesNav"
            class="flex flex-col items-stretch gap-4 mt-10 w-full min-w-0">
            <div class="flex items-center justify-center w-full px-4 sm:px-6 lg:px-2 max-w-[1400px] mx-auto min-w-0">
                <h2 class="text-gray-500 font-medium text-2xl lg:text-3xl text-center">التصنيفات</h2>
            </div>
            <div
                class="w-full max-w-[1400px] mx-auto min-w-0 px-2 sm:px-2 overflow-x-auto overflow-y-hidden scrollbar-none overscroll-x-contain touch-pan-x">
                <div
                    id="normal-categories-nav"
                    class="flex w-max min-w-full flex-nowrap justify-center gap-4 lg:gap-6 pb-1
                        sm:grid sm:w-full sm:min-w-0 sm:flex-none sm:pb-0 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 sm:justify-items-center">
                    <CategoryItem :is-fast-delivery="false" v-for="category in productsStore.categories" :key="category.id"
                        :category-data="category"
                        :selected-category="productsStore.selectedCategoryId"
                        class="shrink-0 min-w-36 max-w-36 lg:min-w-[9.5rem] lg:max-w-[9.5rem] xl:min-w-40 xl:max-w-40"
                        @select="handleCategoryPick" />
                </div>
            </div>
        </div>
        <Transition>
            <nav v-show="showStickyCategoriesNav"
                :style="{ top: stickyTopPx + 'px' }"
                class="overflow-x-clip overflow-y-hidden bg-white fixed z-[38] inset-x-0 w-full border-b border-gray-200 lg:inset-x-auto lg:left-1/2 lg:right-auto lg:-translate-x-1/2 lg:w-[min(100%,1600px)] lg:max-w-[1600px] lg:rounded-b-xl lg:shadow-sm lg:border-x lg:border-gray-100">
                <div
                    class="mx-auto max-w-[1400px] overflow-x-auto overflow-y-hidden scrollbar-none overscroll-x-contain touch-pan-x py-3 px-3 sm:px-5 md:px-8 lg:px-8 xl:px-10">
                    <div
                        class="flex w-max min-w-full flex-nowrap items-start justify-center gap-3 sm:gap-4 md:gap-5">
                        <CategoryItem :is-fast-delivery="false" v-for="category in productsStore.categories" :key="category.id"
                            :category-data="category"
                            :selected-category="productsStore.selectedCategoryId"
                            class="shrink-0 min-w-36 max-w-36 lg:min-w-[9.5rem] lg:max-w-[9.5rem] xl:min-w-40 xl:max-w-40"
                            @select="handleCategoryPick" />
                    </div>
                </div>
            </nav>
        </Transition>

        <div v-for="(category, index) in filteredProducts" :key="category.id" class="my-12"
            :id="'category-' + category.id"
            :data-category-section-id="category.id"
            :data-custom-id="'number-' + index" :data-category-id="category.id">
            <div class="mt-6 mb-4 px-6 lg:px-2 font-medium text-gray-500 text-2xl lg:text-3xl max-w-[1400px] mx-auto text-center">
                {{ category.name }}
            </div>
            <div
                class="grid max-w-[1400px] mx-auto min-w-0 w-full px-1 grid-cols-3 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-x-2 sm:gap-x-3 gap-y-6 justify-items-center">
                <ProductItem v-for="product in category.categ_ids" :key="product.id" :product-data="product"
                    :is-seasonal="category.is_seasonal" @click="openModal(product, category.is_seasonal, category)" />
            </div>
        </div>
        </template>
    </div>
</AppLayout>
</template>

<script setup>
import AppLayout from "@/layouts/AppLayout.vue";
import CategoryItem from "@/components/CategoryItem.vue";
import ProductItem from "@/components/ProductItem.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import FirstVisitLoader from "@/components/FirstVisitLoader.vue";
import { useProductsStore } from "@/stores/products.store";
import { computed, ref, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import Slider from "@/components/Slider.vue";
import Modal from "@/components/Modal.vue";
import { useCartStore } from "@/stores/cart.store";
import {
    trackViewItem,
    trackViewItemList,
    trackSelectItem,
    trackSelectCategory,
    trackSearch,
    trackFirstOpen,
} from '@/helpers/analytics.js'
import { filterCategoriesBySearch } from '@/helpers/productSearch.js'
import { applyCategoryPageSeo, applyCategoryUnavailableSeo } from "@/helpers/seo.js";
const router = useRouter();
const route = useRoute();
const productsStore = useProductsStore();
const cartStore = useCartStore();

const selectCategory = (id) => {
    productsStore.selectedCategoryId = id;
};

/** false only briefly after category navigation so scroll-spy does not fight smooth scroll */
let isScrolling = true;
let lastCategoryRouteTrackedId = "";

function scrollToCategorySection(categoryId) {
    const targetElement = document.querySelector(`[data-category-section-id="${categoryId}"]`);
    if (!targetElement) {
        return;
    }
    const threshold = getMainNavBottom();
    const stickyExtra = showStickyCategoriesNav.value ? 88 : 0;
    const targetPosition =
        window.scrollY +
        targetElement.getBoundingClientRect().top -
        threshold -
        SCROLL_SPY_OFFSET -
        stickyExtra;
    window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: "smooth",
    });
}

function runCategoryRouteEffects({ scroll = true } = {}) {
    if (route.name !== "category-detail") {
        return;
    }
    const found = productsStore.findCategoryById(route.params.id);
    if (!found?.category) {
        if (!productsStore.isLoading && productsStore.catalogBootstrapAttempted) {
            applyCategoryUnavailableSeo();
        }
        return;
    }
    selectCategory(found.category.id);
    const routeId = String(route.params.id);
    if (lastCategoryRouteTrackedId !== routeId) {
        lastCategoryRouteTrackedId = routeId;
        trackSelectCategory({
            categoryId: found.category.id,
            categoryName: found.category.name,
        });
    }
    applyCategoryPageSeo(found.category);
    if (!scroll || import.meta.env.SSR) {
        return;
    }
    isScrolling = false;
    nextTick(() => {
        requestAnimationFrame(() => scrollToCategorySection(found.category.id));
    });
    setTimeout(() => {
        isScrolling = true;
    }, 1000);
}

function handleCategoryPick(category) {
    if (!category?.id) {
        return;
    }
    const routeId = String(category.id);
    if (route.name === "category-detail" && String(route.params.id) === routeId) {
        runCategoryRouteEffects({ scroll: true });
        return;
    }
    router.push({ name: "category-detail", params: { id: routeId } });
}

watch(
    () => [
        route.name,
        route.params.id,
        productsStore.categories?.length || 0,
        productsStore.isLoading,
        productsStore.catalogBootstrapAttempted,
    ],
    () => {
        if (route.name !== "category-detail") {
            return;
        }
        if (productsStore.isLoading || !(productsStore.categories?.length)) {
            return;
        }
        runCategoryRouteEffects({ scroll: true });
    },
    { immediate: true }
);
const openModal = (product, isSeasonal = false, category = null) => {
    productsStore.isSeasonal = isSeasonal;
    const categoryName = category?.name;
    const listId = category?.id != null ? String(category.id) : isSeasonal ? "seasonal" : "home";
    const listName = categoryName || (isSeasonal ? "Seasonal" : "Home");
    const enriched = categoryName
        ? { ...product, category_name: categoryName, item_category: categoryName }
        : product;
    trackSelectItem(enriched, {
        itemListId: listId,
        itemListName: listName,
        categoryName,
    });
    trackViewItem(enriched, {
        isSeasonal,
        itemListId: listId,
        itemListName: listName,
        categoryName,
    });
    router.push({
        name: "product-detail",
        params: { id: String(product.id) },
        query: isSeasonal ? { seasonal: "1" } : {},
    });
};
/*
function findProductById(id) {
    const numId = Number(id);
    const allCats = [...(productsStore.categories || []), ...(productsStore.fastDeliveryData || [])];
    for (const category of allCats) {
        const product = category.categ_ids?.find(p => p.id === numId);
        if (product) return { product, isSeasonal: !!category.is_seasonal };
    }
    return null;
}

// Watch for categories to load then handle ?id= deep link
const _deepLinkHandled = ref(false);
watch(
    () => productsStore.categories,
    (newCategories) => {
        if (_deepLinkHandled.value || !route.query.id || !newCategories?.length) return;
        const found = findProductById(route.query.id);
        if (found) {
            _deepLinkHandled.value = true;
            openModal(found.product, found.isSeasonal);
        }
    },
    { immediate: true, deep: false }
);
*/
function firstOpen() {
    trackFirstOpen();
}

const catalogEmpty = computed(
    () => !(productsStore.categories?.length) && !(productsStore.fastDeliveryData?.length)
);
/** Main grid: only normal categories; show loader until first catalog is ready */
const showHomeCatalogLoader = computed(
    () => catalogEmpty.value && productsStore.isLoading
);

const filteredProducts = computed(() =>
    filterCategoriesBySearch(productsStore.allCategories, productsStore.searchQuery)
);

/** Dedupe view_item_list / search so re-renders of the same catalog do not spam. */
let lastTrackedListSignature = "";
let searchTrackTimer = null;

function trackVisibleProductLists(categories) {
    if (!Array.isArray(categories) || !categories.length) {
        return;
    }
    const searchQuery = productsStore.searchQuery.trim();
    const signature = searchQuery
        ? `search:${searchQuery}:${categories.map((c) => `${c.id}:${(c.categ_ids || []).length}`).join("|")}`
        : `home:${categories.map((c) => `${c.id}:${(c.categ_ids || []).length}`).join("|")}`;
    if (signature === lastTrackedListSignature) {
        return;
    }
    lastTrackedListSignature = signature;

    if (searchQuery) {
        clearTimeout(searchTrackTimer);
        searchTrackTimer = setTimeout(() => {
            trackSearch(searchQuery);
        }, 400);
        const products = categories.flatMap((c) =>
            (c.categ_ids || []).map((p) => ({
                ...p,
                category_name: c.name,
                item_category: c.name,
            }))
        );
        trackViewItemList({
            products,
            itemListId: "search_results",
            itemListName: "Search Results",
        });
        return;
    }

    for (const category of categories) {
        const products = category.categ_ids || [];
        if (!products.length) {
            continue;
        }
        trackViewItemList({
            products,
            itemListId: category.id,
            itemListName: category.name,
            categoryName: category.name,
        });
    }
}

watch(
    filteredProducts,
    (cats) => {
        trackVisibleProductLists(cats);
    },
    { immediate: true }
);

const showNormalCategoriesNav = ref(true);
const showStickyCategoriesNav = ref(false);
/** Below main navbar; synced from real layout (SSR default until client measures). */
const stickyTopPx = ref(60);
/** Extra pixels below header bottom for scroll-spy “current section” probe */
const SCROLL_SPY_OFFSET = 80;

function getMainNavBottom() {
    if (import.meta.env.SSR) {
        return 60;
    }
    const nav = document.getElementById("tazej-main-navbar");
    if (!nav) {
        return 60;
    }
    return Math.max(0, Math.ceil(nav.getBoundingClientRect().bottom));
}

function handleScroll() {
    const trigger = document.getElementById("categories-sticky-trigger");
    if (!trigger) {
        return;
    }
    const threshold = getMainNavBottom();
    stickyTopPx.value = threshold;
    const rect = trigger.getBoundingClientRect();
    const showSticky = rect.top < threshold;
    showNormalCategoriesNav.value = !showSticky;
    showStickyCategoriesNav.value = showSticky;
}

function selectNavbarWithScrolling() {
    if (!isScrolling) {
        return;
    }
    const scrollY = window.scrollY;
    const headerBottom = getMainNavBottom();
    const probeY = scrollY + headerBottom + SCROLL_SPY_OFFSET;

    let currentId = null;
    document.querySelectorAll('[data-custom-id^="number-"]').forEach((category) => {
        const rect = category.getBoundingClientRect();
        const topDoc = rect.top + scrollY;
        const bottomDoc = rect.bottom + scrollY;
        if (probeY >= topDoc && probeY < bottomDoc) {
            currentId = Number(category.getAttribute("data-category-id"));
        }
    });

    if (currentId !== null && currentId !== productsStore.selectedCategoryId) {
        selectCategory(currentId);
    }
}

watch(filteredProducts, () => {
    nextTick(() => {
        handleScroll();
    });
});

function onResizeOrScrollMeta() {
    handleScroll();
}

onMounted(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("scroll", selectNavbarWithScrolling);
    window.addEventListener("resize", onResizeOrScrollMeta);
    document.body.style.overflow = ''; // Ensure scrolling is enabled when returning to the page
    firstOpen();
    if (typeof window.AF === "function") {
        window.AF("pba", "event", {
            name: "test_event",
            properties: {
                userId: "123",
                testParam: "hello",
            },
        });
    }
});

onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("scroll", selectNavbarWithScrolling);
    window.removeEventListener("resize", onResizeOrScrollMeta);
    document.body.style.overflow = ''; // Reset body overflow to ensure scrolling works
});
</script>

<style scoped>
#main-card {
    background-image: url("/public/img/Banner.png");
    background-size: cover;
}

.card-overlay {
    height: 181px;
}

.card-overlay {
    height: 181px;
}

@media (min-width: 412px) and (max-width: 932px) {
    .card-overlay {
        height: 200px;
    }
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
